import { Component,ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonModal, ModalController } from '@ionic/angular';
import { NotifierService } from 'angular-notifier';
import domtoimage from 'dom-to-image';
import jsPDF from 'jspdf';
import SignaturePad from 'signature_pad';
import { Visitor } from '../models/visitor.model';
import { VisitorChild } from '../models/visitorChild';
import { LanguageService } from '../../services/language.service';
import { VisitorService } from '../services/visitor.service';

@Component({
  selector: 'app-consent-group-visit',
  templateUrl: './consent-group-visit.component.html',
  styleUrls: ['./consent-group-visit.component.scss'],
})
export class ConsentGroupVisitComponent implements OnInit {

  @ViewChild(IonModal) modal: IonModal;
  @ViewChild('canvas', { static: true }) signaturePadElement;
  @ViewChild('registerDoc')
  registerDoc!: ElementRef;
  @ViewChild('terms')
  terms!: ElementRef;
  @ViewChild('logo')
  logo!: ElementRef;
  @ViewChild('submitBtn')
  submitBtn!: ElementRef;
  @ViewChild('dateLabel')
  dateLabel!: ElementRef;
  @ViewChild('visitorForm')
  visitorForm!: ElementRef;
  language$ = this.languageService.language$;
  language: string;
  dateToday = new Date();
  areTermsRead: boolean = false;
  visitor: Visitor = new Visitor();
  isLoading = false;
  visitors: Array<VisitorChild> = [];
  isShow = false;
  isChildFormVisible = false;
  childEdit: VisitorChild;
  errMsg = '';
  private sub: any;
  id: any;

  constructor(private elementRef: ElementRef,
    private router: Router,
    private languageService: LanguageService,
    private visitorService: VisitorService,
    private notifierService: NotifierService,
    private modalController: ModalController, 
    private route : ActivatedRoute) 
    {
      this.sub = this.route
      .params
      .subscribe(params => {
        console.log(params);
        this.visitor = JSON.parse(params["visitor"]);
        console.log(this.visitor);
        this.visitors = JSON.parse(params["visitors"]);
      });
    }
 
  pagePath: string;
  signaturePad: any;
  isSignatured: boolean = false;
  ngOnInit() {
    this.language$.subscribe((lng) => (this.language = lng.toUpperCase()));
    this.pagePath = this.router.url;
    const canvas: any = this.elementRef.nativeElement.querySelector('canvas');
    canvas.width = 600;
    canvas.height = 180;
    if (this.signaturePad) {
      this.signaturePad.clear(); // Clear the pad on init
    }
  }

  toggleLanguage() {
    this.language = this.language === 'EN' ? 'SR' : 'EN';
    this.languageService.setLanguage(this.language.toLowerCase());
  }

  clear() {
    this.signaturePad.clear();
    this.isSignatured = false;
  }

  setIsSignatured() {
    this.isSignatured = true;
  }

  isCanvasBlank(): boolean {
    if (this.signaturePad) {
      return this.signaturePad.isEmpty() ? true : false;
    }
  }
  areFieldsPopulated(): boolean {
    return !!(
      this.isSignatured &&
      this.areTermsRead 
    );
  }
  validateAddVisitor() {
    const user = this.visitor;
    let errMsg: string;
    if (!user.fullName) {
      errMsg = 'Unesite ime roditelja / staratelja.';
    // else if (!user.children) {
    //   errMsg = 'Unesite ime korisnika.'; }
    } else if (!user.email) {
      errMsg = 'Unesite e-mail adresu.';
    } else if (!user.phone) {
      errMsg = 'Unesite broj telefona.';
    } else if (!user.address) {
      errMsg = 'Unesite adresu.';
    } else {
      errMsg = '';
      return { isValid: true, errMsg };
    }
    return { isValid: false, errMsg };
  }

  ngAfterViewInit(): void {
    this.signaturePad = new SignaturePad(
      this.signaturePadElement.nativeElement
    );
    this.signaturePad.clear();
    // mozemo dodatno smanjiti debljinu potpisa
    // this.signaturePad.minWidth = 1;
    // this.signaturePad.maxWidth = 1;
    this.signaturePad.penColor = 'rgb(56,128,255)';
  }

 

  async saveRegistration() {
    this.isLoading = true;
    const formValidation = this.validateAddVisitor();
    this.errMsg = formValidation.errMsg;
    if (formValidation.isValid) {
      const that = this;
      let div = this.registerDoc.nativeElement;
      let terms = this.terms.nativeElement;
      let logo = this.logo.nativeElement;
      let dateLabel = this.dateLabel.nativeElement;
      let submitBtn = this.submitBtn.nativeElement;
      dateLabel.style = 'display: block';
      submitBtn.style = 'visibility: hidden';
      //logo.style =  'top: 25px; left: -75px';
      let img: any;
      //--let filename;
      let newImage: any;

      domtoimage
        .toJpeg(div, { bgcolor: 'black' })
        .then(function(dataUrl) {
          img = new Image();
          img.src = dataUrl;
          newImage = img.src;
          img.onload = function() {
            const pdfWidth = img.width;
            const pdfHeight = img.height;

            // FileSaver.saveAs(dataUrl, 'my-pdfimage.png'); // Save as Image
            let doc: jsPDF;
            if (pdfWidth > pdfHeight) {
              doc = new jsPDF('l', 'px', [pdfWidth, pdfHeight]);
            } else {
              doc = new jsPDF('p', 'px', [pdfWidth, pdfHeight]);
            }

            const width = doc.internal.pageSize.getWidth();
            const height = doc.internal.pageSize.getHeight();

            doc.addImage(newImage, 'JPG', 10, 10, width, height);
            // filename = 'mypdf_' + '.pdf';
            // doc.save(filename);
            //terms.style = 'max-height: 250px; color: white; overflow:auto; opacity: 0.5; width: 586px;'
            submitBtn.style = 'visibility: visible';
            dateLabel.style = 'display: none';
            //logo.style =  'top: 130px; left: -217px';


            that.visitorService
              .saveGroupRegistration(that.visitor,that.visitors, doc.output('blob'))
              .subscribe(() => {
                that.isLoading = false;
                that.showSuccessAndRedirect();
              },
              error => {
                console.log('greska');
                console.log(error);
               that.showErrorAndRedirect(error);
              }
              );
          };
        })
    }
  }

  showErrorAndRedirect(error) {
    this.notifierService.show({
      message: '' + JSON.stringify(error.error.title),
      type: 'warning',
    });
    this.isLoading = false;
  }

  showSuccessAndRedirect() {
    this.notifierService.show({
      message: 'Grupna poseta uspešno registrovana!',
      type: 'success',
    });
    this.visitor = new Visitor();
    this.visitors = [];
    this.areTermsRead = false;
    this.signaturePad.clear();
    this.router.navigateByUrl('/registration/home');
  }
  



}

